/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElTabs as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/tabs/style/css';
import { ElTabPane as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/tab-pane/style/css';
import { ElForm as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElInput as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7687481c"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "*", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "red"
}, "*", -1));
const _hoisted_3 = {
  class: "dialog-footer"
};
import RoleList from './roleList.vue';
import GameList from './gameList.vue';
import { apiAdminAuth, apiAdminInvite } from '@/api/user';
export default /*#__PURE__*/_defineComponent({
  __name: 'addEditAccount',
  emits: ['success'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emits = __emit;
    const type = ref('add');
    const userId = ref();
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const formRef = ref();
    const form = ref({
      username: '',
      realname: '',
      phone: '',
      email: ''
    });
    const selectGames = ref([]);
    const roleArr = ref([]);
    const allGames = ref(false);
    const handleClose = formEl => {
      dialogVisible.value = false;
      if (!formEl) return;
      formEl.resetFields();
      form.value = {
        username: '',
        realname: '',
        phone: '',
        email: ''
      };
      selectGames.value = [];
      roleArr.value = [];
      allGames.value = false;
    };
    const changeGame = (val, all) => {
      selectGames.value = val;
      allGames.value = all;
    };
    const changeRole = arr => {
      roleArr.value = arr;
    };
    const handleOk = () => {
      if (!form.value.username || !form.value.realname || !form.value.phone) {
        ElMessage.warning('请完善基本信息！');
        return;
      }
      if (roleArr.value.length === 0) {
        ElMessage.warning('请选择角色授权！');
        return;
      }
      confirmLoading.value = true;
      if (type.value === 'add') {
        apiAdminInvite({
          ...form.value,
          auth_info: {
            is_all_games: 0,
            games: selectGames.value,
            roles: roleArr.value.map(item => {
              return {
                role_id: item.RoleId,
                can_access: item.CanAccess,
                can_auth: item.CanAuth
              };
            }),
            is_invite: true
          }
        }).then(res => {
          if (res.code == 0) {
            emits('success');
            handleClose(formRef.value);
          }
        }).finally(() => {
          confirmLoading.value = false;
        });
      } else {
        apiAdminAuth({
          user_ids: [userId.value],
          auth_info: {
            is_all_games: 0,
            games: selectGames.value,
            roles: roleArr.value.map(item => {
              return {
                role_id: item.RoleId,
                can_access: item.CanAccess,
                can_auth: item.CanAuth
              };
            })
          }
        }).then(res => {
          if (res.code === 0) {
            emits('success');
            handleClose(formRef.value);
          }
        }).finally(() => {
          confirmLoading.value = false;
        });
      }
    };
    const show = payload => {
      dialogVisible.value = true;
      type.value = payload.type;
      if (payload.data) {
        userId.value = payload.data.Id;
        form.value = {
          email: payload.data.Email,
          phone: payload.data.Phone,
          username: payload.data.UserName,
          realname: payload.data.Realname
        };
      }
    };
    __expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_input = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_form = __unplugin_components_2;
      const _component_el_tab_pane = __unplugin_components_3;
      const _component_el_tabs = __unplugin_components_4;
      const _component_el_button = __unplugin_components_5;
      const _component_el_dialog = __unplugin_components_6;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: `${_unref(type) === 'add' ? '新增' : '编辑'}子账号`,
        "before-close": () => handleClose(_unref(formRef)),
        "destroy-on-close": ""
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => handleClose(_unref(formRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: _unref(confirmLoading),
          onClick: _cache[5] || (_cache[5] = $event => handleOk())
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_tabs, {
          "tab-position": "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_tab_pane, null, {
            label: _withCtx(() => [_hoisted_1, _createTextVNode(" 基本信息 ")]),
            default: _withCtx(() => [_createVNode(_component_el_form, {
              model: _unref(form),
              ref_key: "formRef",
              ref: formRef,
              "label-width": "120px",
              disabled: _unref(type) === 'edit'
            }, {
              default: _withCtx(() => [_createVNode(_component_el_form_item, {
                label: "用户名",
                prop: "username",
                rules: {
                  required: true,
                  message: '请输入用户名',
                  trigger: 'change'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).username = $event),
                  placeholder: "添加后不支持修改"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "姓名",
                prop: "realname",
                rules: {
                  required: true,
                  message: '请输入姓名',
                  trigger: 'change'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).realname,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).realname = $event),
                  placeholder: "请输入真实姓名"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "手机号",
                prop: "phone",
                rules: {
                  required: true,
                  message: '请输入手机号',
                  trigger: 'change'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).phone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).phone = $event),
                  placeholder: "用户接收验证码以激活账号"
                }, null, 8, ["modelValue"])]),
                _: 1
              }), _createVNode(_component_el_form_item, {
                label: "邮箱",
                prop: "email"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(form).email = $event),
                  placeholder: "用户接收通知"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["model", "disabled"])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, null, {
            label: _withCtx(() => [_hoisted_2, _createTextVNode(" 角色授权 ")]),
            default: _withCtx(() => [_createVNode(RoleList, {
              "user-id": _unref(userId),
              onChangeCheck: changeRole
            }, null, 8, ["user-id"])]),
            _: 1
          }), _createVNode(_component_el_tab_pane, {
            label: "游戏授权"
          }, {
            default: _withCtx(() => [_createVNode(GameList, {
              "user-id": _unref(userId),
              onChange: changeGame
            }, null, 8, ["user-id"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "title", "before-close"]);
    };
  }
});